module.exports = __webpack_public_path__ + "img/documents-linked-to-twin.43824d59.png";